// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import { format } from 'date-fns';
// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

// Section for type definition -----------------------------------------------------------------------------------------
import MansionRenovationHistoriesPropsData from '@/types/components/MansionDetail/MansionRenovationHistoriesPropsData';

type MansionRenovationHistoriesPickUpProps = {
  mansionRenovationHistories: MansionRenovationHistoriesPropsData[];
};

export default function MansionRenovationHistoriesPickUp(props: MansionRenovationHistoriesPickUpProps) {
  const { mansionRenovationHistories } = props;
  return (
    <Box id="mansionRenovationHistoryPreview" className="py-2 max-md:py-1">
      <Container className="md:max-w-7xl md:w-full md:mx-auto md:px-24">
        <Box className="px-10 max-md:px-4 py-6 max-md:py-5 bg-[#FFECEC] rounded-lg">
          <Box className="flex justify-center items-center gap-3 h-9 mb-6 rounded-lg balloon-renovation">
            <HomeRoundedIcon className="text-rf-red" />
            <Typography
              component="h3"
              variant="h3"
              className="text-base text-rf-red font-bold text-center leading-relaxed max-md:leading-[22px] tracking-wide"
            >
              このマンションリノベしました！
            </Typography>
          </Box>
          <Box className="mt-5 mx-auto flex flex-col gap-y-3">
            {mansionRenovationHistories.map((mansionRenovationHistoriesData) => (
              <Box
                key={mansionRenovationHistoriesData.id}
                className="md:flex md:justify-between md:items-center max-md:gap-x-2"
              >
                <Link href={`#rf-${mansionRenovationHistoriesData.id}`} className="flex gap-x-4 max-md:gap-x-2">
                  <Box>
                    <CheckRoundedIcon className="text-rf-black" />
                  </Box>
                  <Box className="flex items-center justify-between">
                    <Typography className="pt-1 text-base max-md:text-sm text-rf-blue underline break-words break-all">
                      {mansionRenovationHistoriesData.title}
                    </Typography>
                  </Box>
                </Link>
                <Box className="flex gap-x-2 items-end justify-end">
                  <Typography className="text-xs leading-7 text-[#000000] no-underline">
                    {mansionRenovationHistoriesData.fcShopName}
                  </Typography>
                  <Typography className="text-xs leading-7 text-[#000000] no-underline">
                    {format(new Date(mansionRenovationHistoriesData.date), 'yyyy/MM/dd')}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
